import gtag_event from './gtag-init';
import {otp_init} from '../global/otp';
import {whatsapp_validation_form} from '../global/validation-form';
import {insert_leads_to_db} from '../global/leads-submission';

jQuery(function ($) {
    // eslint-disable-next-line no-undef
    let custom_copy_leads = global_params['custom_copy_leads'];
    var current_wa_button_clicked_position = null;
    const GENERAL_WA_MODAL_ID = '#whatsapp-form-modal';
    const CONTACT_CLASS = '.section-contact-form-elementor';
    const WA_FORM_CLASS = 'form.whatsapp-form-elementor';
    const BANNER_SECTION_CLASS = 'section.section-banner-v2';
    const LEADS_COVER = '#whatsapp-form-modal div.leads-cover';
    const CONTACT_WA_CLASS = 'section.contact';

    // init global vars
    var microsite_whatsapp_modal = null;
    var current_form_class = null;
    var name_field = null;
    var number_field = null;
    var message_field = null;
    var alert_field = null;
    var process_submit = false;
    var url_redirect = null;
    // var custom_pretext_wa = null;

    function change_wa_form_vars(_microsite_whatsapp_modal) {
      microsite_whatsapp_modal = _microsite_whatsapp_modal;
      current_form_class = microsite_whatsapp_modal + ' ' + WA_FORM_CLASS;
      name_field = $(current_form_class + ' [name="name"]');
      number_field = $(current_form_class + ' [name="whatsapp_number"]');
      message_field = $(current_form_class + ' [name="message"]');
      alert_field = $(current_form_class + ' .message-failed');
      
    }
    change_wa_form_vars(GENERAL_WA_MODAL_ID);

    function change_wa_form(selector) {
      let _big_title = selector.attr('data-title');
      let _title = selector.attr('data-description');
      let _btn_submit = selector.attr('data-submit');
      let _is_download_brochure = 0;
      let _download_brochure_url = '';
      let _lead_type_id = 1;
      let _lead_type_name = 'Whatsapp';
      let _leads_cover = selector.attr('data-cover');
      let _leads_submit_color = selector.attr('data-submit-leads-color');
      let _leads_submit_background = selector.attr('data-submit-leads-background');
      let _data_lead_type = selector.attr('data-lead-type');

      console.info(_data_lead_type);

      if ( selector.hasClass('btn-download-brochure') ) {
          _is_download_brochure = 1;
          _download_brochure_url = selector.attr('href');
          _lead_type_id = 3;
          _lead_type_name = 'Brochure';
      }

      if (_data_lead_type != ''){
        _lead_type_name = _data_lead_type;
      }

      if ( custom_copy_leads['is_custom_copy_leads'] == true && !selector.hasClass('btn-download-brochure')) {
        _big_title = custom_copy_leads['title'];
        _title = custom_copy_leads['subtitle'];
      }

      // clear form
      name_field.val('');
      number_field.val('');
      $(current_form_class + ' select').prop('selectedIndex', 0);

      $(LEADS_COVER).html('<img class="w-100 h-100 cover desktop-border-radius-left-top-bottom" style="height: 100vh !important;" src='+_leads_cover+'>');
      $(microsite_whatsapp_modal + ' .modal-title-lg').text( _big_title );
      $(current_form_class + ' .modal-title').text( _title );
      $(current_form_class + ' [type="submit"]').text( _btn_submit );
      $(current_form_class + ' [name="is_download_brochure"]').val( _is_download_brochure );
      $(current_form_class + ' [name="download_brochure_url"]').val( _download_brochure_url );
      $(current_form_class + ' [name="lead_type_id"]').val( _lead_type_id );
      $(current_form_class + ' [name="lead_type_name"]').val( _lead_type_name );
      $(current_form_class + ' [type="submit"]').prop( 'disabled', false ).css({color: _leads_submit_color, background: _leads_submit_background});
    }

    function submit_whatsapp_form(data) {
      if (data == -1 || data == '') {
        alert_field.text('Mohon maaf ada kesalahan. Silakan refresh halaman kemudian coba lagi.').show();
        return;
      }

      console.log(data);
      // submit success
      if(data.success) {
        $(current_form_class + ' [name=submit_status]').val('1').trigger('change');

        // send GA tracking
        gtag_event('Whatsapp Submission', current_wa_button_clicked_position);

        if ( $(current_form_class + ' [name="is_download_brochure"]').val() == 1 ) {
          do_download_brochure();
        } else {
         redirect_submit_whatsapp_form();
        }
      } else {
        $(current_form_class + ' .message-success').hide();
        $(current_form_class + ' .message-failed').html('<p>' + data.data.message + '</p>').show();
      }
    }

    function redirect_submit_whatsapp_form() {

      $(current_form_class + ' .modal-body label').hide();
      $(current_form_class + ' .modal-body input').hide();
      $(current_form_class + ' .modal-body button').hide();
      $(current_form_class + ' .message-success').show();

      var project_name = $(current_form_class + ' [name=project_name]').val();
      var telesales_number = $(current_form_class + ' [name=telesales_number]').val
      ();
      var redirect = null;
      var sender_name = $(current_form_class + ' [name=name]').val();
      // var msg = message_field.val() != undefined ? message_field.val()+' - ' : 'Saya%20ingin%20bertanya%20mengenai%20info%20';
      var msg = msg_pretext(project_name,sender_name);
      var redirect_default = whatsapp_base_url()+'/send?text='+msg+''+ '&phone=' + telesales_number;
  
      if(url_redirect != undefined && url_redirect !=''){
        let replace_project_name = {
          'text': url_redirect,
          'target': '[project_name]',
          'replace': project_name,
        };

        let replace_sender_name = {
          'text': replace_all_text(replace_project_name),
          'target': '[sender_name]',
          'replace': sender_name,
        };

        let replace_wa_host_url_dekstop = {
          'text': replace_all_text(replace_sender_name),
          'target': 'https://api.whatsapp.com',
          'replace': whatsapp_base_url(),
        };

        let replace_wa_host_url_mobile = {
          'text': replace_all_text(replace_wa_host_url_dekstop),
          'target': 'https://web.whatsapp.com',
          'replace': whatsapp_base_url(),
        };

        redirect = replace_all_text(replace_project_name);
        redirect = replace_all_text(replace_sender_name);
        redirect = replace_all_text(replace_wa_host_url_mobile);
      } else{
        redirect = redirect_default;
      }
      
      setTimeout(function() {
        location.href = redirect
      }, 1000); // 1 second
    }

    function msg_pretext(project) {
      let msg = 'Saya%20ingin%20bertanya%20mengenai%20info%20'+encodeURIComponent(project);
      let msg_from_custom_pretext_cta = message_field.val();

      if(msg_from_custom_pretext_cta != undefined && msg_from_custom_pretext_cta != '') {

        let replace_project_name = {
          'text': msg_from_custom_pretext_cta,
          'target': '[project_name]',
          'replace': project,
        };
        
        msg = encodeURIComponent( replace_all_text(replace_project_name));
        
      }
      if( !is_mobile() ){
        msg = decodeURIComponent(msg);
      }

      return msg;
    }

    function whatsapp_base_url() {
      if( is_mobile() ) {
        return 'https://api.whatsapp.com';
      }

      return 'https://web.whatsapp.com';
    }

    function replace_all_text(data) {
      let text = data.text;
      let target = data.target;
      let replace_with = data.replace;
      let result = text.replaceAll(target, replace_with);
      return result;
    }

    function do_download_brochure() {
      var sender_name = $(current_form_class + ' [name=name]').val();
      var project_name = $(current_form_class + ' [name=project_name]').val();
      $(microsite_whatsapp_modal).modal('hide');

      let _url = $(current_form_class + ' [name="download_brochure_url"]').val();
      let _url_decode = atob( _url );

      let replace_project_name = {
        'text': _url_decode,
        'target': '[project_name]',
        'replace': project_name,
      };

      let replace_sender_name = {
        'text':replace_all_text(replace_project_name),
        'target': '[sender_name]',
        'replace': sender_name,
      };

      let replace_wa_host_url = {
        'text': replace_all_text(replace_sender_name),
        'target': 'https://api.whatsapp.com',
        'replace': whatsapp_base_url(),
      };
      _url_decode = replace_all_text(replace_wa_host_url);
      
      window.open( _url_decode, '_blank' ).focus();
      window.location.reload();
    }

    function whatsapp_submit_form_ajax(e, frm) {
      e.preventDefault();
      var btn_submit = current_form_class + ' [type="submit"]';

      if(current_wa_button_clicked_position == null) {
        current_wa_button_clicked_position = $(btn_submit).data('position');
      }

      let leads_name = name_field.val();
      let leads_number = number_field.val();
      let leads_form = {
        'name': leads_name,
        'number': leads_number,
        'number_field': number_field,
        'alert_field': alert_field,
      };
     
      if (whatsapp_validation_form(leads_form) == false) {
        gtag_event('Leads form button clicked', current_wa_button_clicked_position+'-not-validated');
        
        return false;
      }

      if (otp_init(current_form_class, e, leads_number, btn_submit) === false) {
        return false;
      }

      if (true === process_submit) {
        alert('Mohon ditunggu, data anda sedang diproses');
        return;
      }

      gtag_event('Leads form button clicked', current_wa_button_clicked_position+'-validated');

      let data_form = frm.serialize() + '&current_url=' + encodeURIComponent(window.location.href);

      // insert leads data to DB
      insert_leads_to_db(frm);

      $.ajax({
        type: frm.attr('method'),
        url: frm.attr('action'),
        data: data_form,
        beforeSend: function() {
          $(current_form_class + ' .message-text').hide();
          $(current_form_class + ' .loader').show();
          $(btn_submit).prop('disabled', true);
          process_submit = true;
        },
        success: function (data) {
          $(current_form_class + ' .loader').hide();
          submit_whatsapp_form(data);
          $(btn_submit).prop('disabled', false);
          process_submit = false;
        },
        error: function (data) {
          console.log('An error occurred.');
          console.log(data);
          $(btn_submit).prop('disabled', false);
          process_submit = false;
        },
      });
    }

    function whatsapp_init(selector) {
      // change form vars
      change_wa_form_vars(GENERAL_WA_MODAL_ID);

      current_wa_button_clicked_position = selector.data('position');
      gtag_event('Whatsapp Button Clicked', current_wa_button_clicked_position);
      change_wa_form( selector );
    }

    // <!------------- Whatsapp button
    // whatsapp button do not remove
    // $('.btn-whatsapp-general').on('click', function () {
    //   whatsapp_init($(this));
    // });

    function is_mobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        return true;
      }else{
        return false;
      }
    }


    let wa_contact_form_class = CONTACT_WA_CLASS + ' ' + WA_FORM_CLASS;
    $(wa_contact_form_class + ' [name="name"]').attr('placeholder', 'Tulis nama lengkap');
    $(wa_contact_form_class + ' [name="whatsapp_number"]').attr('placceholder', 'Tulis nomor Whatsapp');
    $(wa_contact_form_class + ' [type="submit"]').text('Whatsapp');
    // end of Whatsapp button -------------!>

    // <!------------- Whatsapp form submit
    $(GENERAL_WA_MODAL_ID + ' ' + WA_FORM_CLASS).on('submit', function (e) {
      whatsapp_submit_form_ajax(e, $(this));
      
    });

    $(CONTACT_CLASS + ' ' + WA_FORM_CLASS).on('submit', function (e) {
      change_wa_form_vars(CONTACT_CLASS);

      whatsapp_submit_form_ajax(e, $(this));
      
      let _redirect_url = $(CONTACT_CLASS  + ' ' + '.btn').attr('data-redirect');

      url_redirect = _redirect_url;


    });

    $(CONTACT_WA_CLASS + ' ' + WA_FORM_CLASS).on('submit', function (e) {
      // change form vars
      change_wa_form_vars(CONTACT_WA_CLASS);

      whatsapp_submit_form_ajax(e, $(this));


    });

    $(BANNER_SECTION_CLASS + ' ' + WA_FORM_CLASS).on('submit', function () {
      // change form vars
      // change_wa_form_vars(BANNER_SECTION_CLASS);

      // whatsapp_submit_form_ajax(e, $(this));
    });
    // end of Whatsapp form submit -------------!>

    // <!------------- Whatsapp button
    $(document).on('click', '.btn-whatsapp-general', function(){

      // eslint-disable-next-line no-undef
      var gl_params = global_params;

      if (
        gl_params['overwrite_whatsapp'] !== null &&
        typeof gl_params['overwrite_whatsapp'] !== undefined &&
        typeof gl_params['overwrite_whatsapp']['enable'] !== undefined &&
        true === gl_params['overwrite_whatsapp']['enable']
      ) {
        location.href = gl_params['overwrite_whatsapp']['link'];
        return false;
      }

      whatsapp_init($(this));
      $('.bannerv2-slider').slick('slickPause');
    });
});



// WEBPACK FOOTER //
// ./scripts/custom-elementor-widget/whatsapp-submission.js